/**
 * Add "is-sticky" class on element when he is sticky
 * 
 * Usage: <div class="js-sticky-element"></div>
 * 
 * @return {void}
 */
export default function initStickyElements() : void {
    const $stickyElements = document.querySelectorAll<HTMLElement>('.js-sticky-element');

    $stickyElements.forEach($stickyElement => {
        toggleClassWhenSticky($stickyElement, 'is-sticky');
    });
}

/**
 * Add a class on element when he is sticky
 * 
 * @param {HTMLElement} $element Sticky element
 * @param {string} classToAdd Class to add on the element
 * @param {HTMLElement|null} $elementToAddClass Element on which to add the class (default: $element)
 * 
 * @return {void}
 */
export function toggleClassWhenSticky($element: HTMLElement, classToAdd: string, $elementToAddClass?: HTMLElement) : void {
    // Create an empty div and insert it before the $element
    const $observerElement = document.createElement('div');
    $element.parentNode.insertBefore($observerElement, $element);

    $elementToAddClass = $elementToAddClass || $element;

    // Add a class to the $elementToAddClass when the $observerElement is out of viewport
    const observer = new IntersectionObserver(entries => {
        $elementToAddClass.classList.toggle(classToAdd, entries[0].intersectionRatio === 0);
    });
    observer.observe($observerElement);
}
